// test1187
(1187 && 0);
